import { useCallback, useEffect, useState } from 'react';

import { type AreaPeriodSelection, parseAreaPeriod, writeAreaPeriod } from './areaPeriod';

export { AREA_PERIODS, DEFAULT_AREA_PERIOD, areaPeriodLabel, isAreaPeriod, type AreaPeriod } from './areaPeriod';

const CHANGED = 'askrichard:pulse-period-changed';

const read = () => parseAreaPeriod(window.location.search);

/** The one Business Pulse time control. Home and every area page read and write the same value. */
export default function useAreaPeriod(): [AreaPeriodSelection, (next: AreaPeriodSelection) => void] {
  const [selection, setSelection] = useState<AreaPeriodSelection>(read);

  useEffect(() => {
    const sync = () => setSelection(read());
    window.addEventListener('popstate', sync);
    window.addEventListener(CHANGED, sync);
    return () => {
      window.removeEventListener('popstate', sync);
      window.removeEventListener(CHANGED, sync);
    };
  }, []);

  const update = useCallback((next: AreaPeriodSelection) => {
    const params = new URLSearchParams(window.location.search);
    writeAreaPeriod(params, next);
    const query = params.toString();
    const url = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;
    if (url !== `${window.location.pathname}${window.location.search}${window.location.hash}`) {
      window.history.pushState(window.history.state, '', url);
    }
    window.dispatchEvent(new Event(CHANGED));
  }, []);

  return [selection, update];
}
